import create from "zustand";

type SideMenuState = {
  showSideAppMenu: boolean;
  toggleSideAppMenu: () => void;
};

const useSideAppMenu = create<SideMenuState>((set, getState) => ({
  showSideAppMenu: false,
  toggleSideAppMenu: () =>
    set((state) => ({ showSideAppMenu: !state.showSideAppMenu }))
}));

export default useSideAppMenu;
